import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../models/base/base-view-model';

@Injectable()
export class ConfirmationModalViewModel extends BaseViewModel {
  constructor() {
    super();
  }
}
